import { useState, type FormEvent } from 'react'
import { Link, getRouteApi } from '@tanstack/react-router'
import { Alert, AuthCard, Button, Field } from '../components/ui'
import { useResetPassword } from '../lib/session'
import { passwordHint } from './RegisterPage'

const route = getRouteApi('/reset-password')

export default function ResetPasswordPage() {
  const { userId, token } = route.useSearch()
  const reset = useResetPassword()
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const mismatch = confirmation.length > 0 && password !== confirmation

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (password !== confirmation) {
      return
    }

    reset.mutate({ userId, token, password, confirmation })
  }

  if (userId === '' || token === '') {
    return (
      <AuthCard title="Reinitialisation du mot de passe">
        <Alert>Ce lien est incomplet. Copiez-le en entier depuis l'e-mail recu.</Alert>
      </AuthCard>
    )
  }

  return (
    <AuthCard title="Nouveau mot de passe">
      {reset.isSuccess ? (
        <>
          <Alert tone="success">Votre mot de passe est modifie. Vous pouvez vous connecter.</Alert>
          <p className="mt-6 text-center text-sm">
            <Link to="/login" className="font-medium underline underline-offset-4">
              Aller a la connexion
            </Link>
          </p>
        </>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <Field
            label="Nouveau mot de passe"
            type="password"
            name="password"
            autoComplete="new-password"
            required
            minLength={12}
            hint={passwordHint}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <Field
            label="Confirmation du mot de passe"
            type="password"
            name="confirmation"
            autoComplete="new-password"
            required
            value={confirmation}
            onChange={(event) => setConfirmation(event.target.value)}
          />

          {mismatch && <Alert>Les deux mots de passe sont differents.</Alert>}
          {reset.isError && <Alert>{reset.error.message}</Alert>}

          <Button type="submit" disabled={reset.isPending || mismatch}>
            {reset.isPending ? 'Enregistrement...' : 'Changer mon mot de passe'}
          </Button>
        </form>
      )}
    </AuthCard>
  )
}
